import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CostaBackendApiService } from '@services/costa-backend-api.service';
import { MenuItemDTO } from '@interfaces/KT/MenuItem.interface';

@Component({
  selector: 'cck-user-menu-aside',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-menu-aside.component.html',
  styleUrls: ['./user-menu-aside.component.scss']
})
export class UserMenuAsideComponent implements OnInit {
  private readonly _costaBackendApiService = inject(CostaBackendApiService);
  public menu: MenuItemDTO[] = [];

  ngOnInit() {
    this._costaBackendApiService.getUserMenuData().then(
      (resp) => {
        this.menu = resp;
      }
    );
  }

  public isCurrentPage(item) {
    return this.getPageTitle(location.pathname) === this.getPageTitle(item.LinkUrl);
  }

  private getPageTitle(url){
    return url.split('/').slice(-1)[0];
  }

  public trackByIndex(idx: number) {
    return idx;
  }
}
